// Please: Alphabetize the exports & properties keys

/**
 * OrganizationInvitation::ROLES
 *
 * Reference: https://github.com/calendly/calendly/blob/master/engines/backend/app/models/organization_invitation.rb
 */
export const ORGANIZATION_INVITATION_ROLES = {
  ADMIN: 'admin',
  USER: 'user'
}

/**
 * OrganizationMembership::ROLES
 *
 * Reference: https://github.com/calendly/calendly/blob/master/engines/backend/app/models/organization_membership.rb
 */
export const ORGANIZATION_MEMBERSHIP_ROLES = {
  ADMIN: 'admin',
  OWNER: 'owner',
  USER: 'user'
}

export const GROUP_ADMIN_ROLE = 'group_admin'
